import { FC } from 'react';
import type { Basics, Meta } from '../types/cv';

const stripProtocol = (url: string) => url.replace(/^[a-z]+:\/\//i, '').replace(/\/$/, '');

interface HeaderProps {
  basics: Basics;
  meta?: Meta;
}

export const Header: FC<HeaderProps> = ({ basics, meta }) => {
  const { name, label, image, email, phone, url, location, profiles } = basics;

  const place = [location?.city, location?.region, location?.countryCode]
    .filter(Boolean)
    .join(', ');

  const links = [
    url && { href: url, text: stripProtocol(url) },
    ...(profiles ?? [])
      .filter(profile => profile.url)
      .map(profile => ({
        href: profile.url as string,
        text: stripProtocol(profile.url as string),
      })),
  ].filter(Boolean) as { href: string; text: string }[];

  return (
    <header className="cv-header">
      <div className="cv-identity">
        <h1 className="cv-name">{name}</h1>
        {label && <p className="cv-label">{label}</p>}

        <ul className="cv-contact">
          {place && <li>{place}</li>}
          {phone && (
            <li>
              <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
            </li>
          )}
          {email && (
            <li>
              <a href={`mailto:${email}`}>{email}</a>
            </li>
          )}
          {links.map(link => (
            <li key={link.href}>
              <a href={link.href}>{link.text}</a>
            </li>
          ))}
        </ul>

        {meta?.eligibility && <p className="cv-eligibility">{meta.eligibility}</p>}
      </div>

      {/* Kept on screen, in print and in the exported PDF. */}
      {image && <img className="cv-photo" src={image} alt={name} />}
    </header>
  );
};

export default Header;
